import analyticsFactory from '@exodus/analytics';

import consoleTrackerDefinition from '@/background/features/analytics/modules/console-tracker';
import analyticsExtraSeedsUserIdsAtomDefinition from './atoms/extra-seeds-user-ids.js';
import userIdAtomDefinition from './atoms/user-id.js';
import analyticsAppConfigPluginDefinition from './plugins/app-config.js';
import fetchHeaderPluginDefinition from './plugins/fetch-header.js';
import analyticsMetadataPluginDefinition from './plugins/metadata.js';
import type { AnalyticsEvents, AnalyticsFactory } from './types.js';
import validateAnalyticsEventDefinition from './validation/event.js';

const analytics = () => {
  const feature = (analyticsFactory as AnalyticsFactory<AnalyticsEvents>)();

  return {
    ...feature,
    definitions: [
      ...feature.definitions,
      {
        definition: userIdAtomDefinition,
        storage: { namespace: 'analytics' },
      },
      {
        definition: analyticsExtraSeedsUserIdsAtomDefinition,
      },
      {
        definition: fetchHeaderPluginDefinition,
      },
      {
        definition: analyticsAppConfigPluginDefinition,
      },
      {
        definition: analyticsMetadataPluginDefinition,
      },
      {
        definition: validateAnalyticsEventDefinition,
      },
      ...(import.meta.env.DEV && __USE_ANALYTICS_CONSOLE_TRACKER__
        ? [
            {
              definition: consoleTrackerDefinition,
            },
          ]
        : []),
    ],
  };
};

export default analytics;
